import { Controller } from "@hotwired/stimulus"
import Chart from "chart.js/auto"

// Asistencia diaria — line chart con 4 series por dia del mes.
// Migra AttendanceTinyBar.tsx (recharts LineChart). Paleta COLOR_CHART.
const SERIES = [
  { key: "total", color: "#000000" },
  { key: "live", color: "#6bd58b" },
  { key: "vod", color: "#D43DEE" },
  { key: "inperson", color: "#2b7ff2" },
]

export default class extends Controller {
  static values = {
    labels: Array,
    total: Array,
    live: Array,
    vod: Array,
    inperson: Array,
    totalLabel: String,
    liveLabel: String,
    vodLabel: String,
    inpersonLabel: String,
  }

  connect() {
    const formatter = new Intl.DateTimeFormat("es", { day: "2-digit", month: "short" })
    const labels = this.labelsValue.map((iso) => formatter.format(new Date(`${iso}T00:00:00`)))

    this.chart = new Chart(this.element.getContext("2d"), {
      type: "line",
      data: {
        labels,
        datasets: SERIES.map(({ key, color }) => ({
          label: this[`${key}LabelValue`],
          data: this[`${key}Value`],
          borderColor: color,
          backgroundColor: color,
          borderWidth: 2,
          tension: 0,
          pointRadius: 0,
          pointHoverRadius: 4,
        })),
      },
      options: {
        responsive: true,
        maintainAspectRatio: false,
        interaction: { mode: "index", intersect: false },
        scales: {
          x: {
            grid: { display: false },
            ticks: { color: "#7a7a7a", font: { size: 12 } },
            border: { display: false },
          },
          y: {
            beginAtZero: true,
            grid: { color: "#dfdfdf" },
            ticks: { color: "#7a7a7a", font: { size: 12 }, precision: 0 },
            border: { display: false },
          },
        },
        plugins: {
          legend: {
            display: true,
            position: "bottom",
            labels: { color: "#7a7a7a", font: { size: 13 }, boxWidth: 12 },
          },
        },
      },
    })
  }

  disconnect() {
    if (this.chart) {
      this.chart.destroy()
      this.chart = null
    }
  }
}
